import * as React from 'react';
import { AgGridReact } from "ag-grid-react";
import { ColDef, IHeaderParams, ICellRendererParams, FirstDataRenderedEvent } from "ag-grid-community";
import { IVoucherSimulationAnnualResult } from '@nkr/models/voucher-simulation';
import SortableHeaderComponent from '@nkr/views/admin/center/list/common/sortable-header';
import { GridWrapper } from './styles';

interface IProps {
    fileId: string,
    list: IVoucherSimulationAnnualResult[],
}

const RunList: React.FunctionComponent<IProps> = (props) => {
    const columns: ColDef[] = [
        {
            headerComponentFramework: (props: IHeaderParams) => <SortableHeaderComponent {...props}>R#</SortableHeaderComponent>,
            headerName: 'Rank',
            field: 'rank',
            width: 50,
            cellClass: 'list-cell',
            headerClass: 'list-header',
            sortable: true
        },
        {
            headerComponentFramework: (props: IHeaderParams) => <SortableHeaderComponent {...props}>Sim #</SortableHeaderComponent>,
            headerName: 'Sim #',
            field: 'simNumber',
            width: 50,
            cellClass: 'list-cell',
            headerClass: 'list-header',
            sortable: true,
            cellRendererFramework: (params: ICellRendererParams) => {
                return (
                    <a href={`${__API__}/voucher/simulation/${props.fileId}/run/${params.value}.csv`}>{params.value}</a>
                );
            }
        },
        {
            headerComponentFramework: (props: IHeaderParams) => <SortableHeaderComponent {...props}>Redeemable Donors</SortableHeaderComponent>,
            headerName: 'Redeemable Donors',
            field: 'donorLiabilityOutstanding',
            cellClass: 'list-cell',
            headerClass: 'list-header',
            sortable: true
        },
        {
            headerComponentFramework: (props: IHeaderParams) => <SortableHeaderComponent {...props}>Redeemable Voucher Holders</SortableHeaderComponent>,
            headerName: 'Redeemable Voucher Holders',
            field: 'familyVoucherLiabilityOutstanding',
            cellClass: 'list-cell',
            headerClass: 'list-header',
            sortable: true
        },
        {
            headerComponentFramework: (props: IHeaderParams) => <SortableHeaderComponent {...props}>Chain Starts</SortableHeaderComponent>,
            headerName: 'Chain Starts',
            field: 'chainStartsTotal',
            cellClass: 'list-cell',
            headerClass: 'list-header',
            sortable: true
        },
        {
            headerComponentFramework: (props: IHeaderParams) => <SortableHeaderComponent {...props}>Chain Starts 'O'</SortableHeaderComponent>,
            headerName: 'Chain Starts O',
            field: 'chainStartsTotalO',
            cellClass: 'list-cell',
            headerClass: 'list-header',
            sortable: true
        },
        {
            headerComponentFramework: (props: IHeaderParams) => <SortableHeaderComponent {...props}>Donors Redeemed</SortableHeaderComponent>,
            headerName: 'Donors Redeemed',
            field: 'donorVoucherRedeemed',
            cellClass: 'list-cell',
            headerClass: 'list-header',
            sortable: true
        },
        {
            headerComponentFramework: (props: IHeaderParams) => <SortableHeaderComponent {...props}>Vouchers Redeemed</SortableHeaderComponent>,
            headerName: 'Vouchers Redeemed',
            field: 'familyVoucherRedeemed',
            cellClass: 'list-cell',
            headerClass: 'list-header',
            sortable: true
        },
        {
            headerComponentFramework: (props: IHeaderParams) => <SortableHeaderComponent {...props}>Coverage Ratio</SortableHeaderComponent>,
            headerName: 'Coverage Ratio',
            field: 'coverageRatio',
            cellClass: 'list-cell',
            headerClass: 'list-header',
            sortable: true,
            cellRendererFramework: (params: ICellRendererParams) => <>{params.value.toFixed(2)}</>
        },
        {
            headerComponentFramework: (props: IHeaderParams) => <SortableHeaderComponent {...props}>Coverage Ratio 'O'</SortableHeaderComponent>,
            headerName: 'Coverage Ratio O',
            field: 'coverageRatioO',
            cellClass: 'list-cell',
            headerClass: 'list-header',
            sortable: true,
            cellRendererFramework: (params: ICellRendererParams) => <>{params.value.toFixed(2)}</>
        }
    ];

    return (
        <GridWrapper className="ag-theme-bootstrap" style={{ height: 350 }}>
            <AgGridReact
                columnDefs={columns}
                rowData={props.list}
                headerHeight={30}
                // context={this.state.context}
                rowHeight={35}
                // noRowsOverlayComponentFramework={() => <div>No RCCAPs found...</div>}
                suppressCellSelection={true}
                suppressRowClickSelection={true}
                onFirstDataRendered={(props: FirstDataRenderedEvent) => {
                    props.api.sizeColumnsToFit();
                }}
            >
            </AgGridReact>
        </GridWrapper>
    );
}

export default RunList;